<template>
  <div>
    <Modal v-model="visible" :title="formTitle" :footer-hide="true" :mask-closable="false" class="my-modal top template-user-detail">
      <Form ref="form" :model="form" :label-width="80" class="modal-form">
        <FormItem prop="organizationIds" :label="key == 'mechan' ? '选择机构' : '选择团队'" :rules="$units.formRule.arrRequired('请选择')">
          <Select v-model="form.organizationIds" :transfer="true" v-if="key == 'mechan'" :multiple="true" filterable>
            <Option v-for="(item, index) in orgList" :value="item.id" :key="index" :label="item.name">
              <span>{{ item.name }}</span>
              <span v-if="item.orgCode">-</span>
              <span class="template-name" :class="{'action': form.organizationIds&&form.organizationIds.includes(item.id)}">{{ item.templateName }}</span>
              <span v-if="item.templateName">-</span>
              <span>{{ item.orgCode }}</span>
            </Option>
          </Select>
          <selectTree ref="selectTreeRef" v-model="form.organizationIds" :multiple="true" v-else></selectTree>
        </FormItem>
      </Form>
      <div class="ivu-modal-footer">
        <Button type="text" @click="visible = false">取消</Button>
        <Button type="primary" @click="addUserSubmit" :loading="loading">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import selectTree from '@/components/system/selectTree3';
import filters from '@/api/filter';

export default {
  props: ['detail'],
  data() {
    return {
      formTitle: '',
      key: '',
      visible: false,
      form: {},
      orgList: [],
      loading: false
    };
  },

  components: {
    selectTree
  },

  methods: {
    open(key) {
      this.loading = false;
      this.key = key;
      delete this.form.organizationIds;
      let url = '';
      let type = '';
      let data = {};
      // 机构
      if (this.key == 'mechan') {
        this.formTitle = '添加机构';
        url = '/buz/organizationBase/queryTemplateOrg';
        type = 'POST';
        data.parentId = this.detail.orgId;
        data.templateId = this.detail.id; //模板id
      } else {
        this.formTitle = '添加团队';
        url = '/buz/organizationGroup/queryTreeByOrgId';
        type = 'GET';
        data.orgId = this.detail.orgId;
      }
      this.$http({
        url,
        type,
        data
      }).then(res => {
        if (!res.data || res.data.length == 0) {
          this.$notice.msg(this.key == 'mechan' ? '暂无需配置服务费的机构' : '暂无需配置服务费的团队');
          return;
        }
        this.visible = true;
        if (this.key == 'mechan') {
          this.orgList = res.data;
        } else {
          this.orgList = res.data;
          this.$refs.selectTreeRef.setData(this.dealTree(res.data));
        }
      });
    },

    dealTree(arr) {
      return arr.map(item => ({
        ...item,
        name: item.label + (item.templateName ? '(' : '') + item.templateName + (item.templateName ? ')' : ''),
        children: item.children && item.children.length > 0 ? this.dealTree(item.children) : []
      }));
    },

    // 确定添加机构/团队
    addUserSubmit() {
      this.$refs.form.validate().then(isok => {
        if (isok) {
          if (this.loading) {
            return;
          }
          this.loading = true;
          let data = {
            templateId: this.detail.id,
            organizationType: this.key == 'mechan' ? 1 : 2,
            templateInfos: []
          };
          if (this.key == 'mechan') {
            this.orgList.forEach(item => {
              if (this.form.organizationIds.includes(item.id)) {
                data.templateInfos.push({
                  organizationId: item.id,
                  oldTemplateId: item.templateId ? item.templateId : ''
                });
              }
            });
          } else {
            let orgList = filters.treeFlatArr(this.orgList);
            orgList.forEach(item => {
              if (this.form.organizationIds.includes(item.id)) {
                data.templateInfos.push({
                  organizationId: item.id,
                  oldTemplateId: item.templateId ? item.templateId : ''
                });
              }
            });
          }
          this.$http({
            url: '/buz/organizationTemplate/applyTemplate',
            type: 'POST',
            data
          })
            .then(res => {
              this.$emit('success');
              this.$notice.success('添加成功');
              this.loading = false;
              this.visible = false;
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    }
  }
};
</script>

<style lang="scss">
.template-user-detail {
  .btn-list {
    text-align: right;
    margin-top: 10px;
  }

  /deep/ {
    .ivu-transfer-list {
      width: 287px;
      height: 400px;
    }
  }

  .table-box {
    margin-top: 20px;
  }
}
.template-name {
  color: #c78d49;
  &.action {
    color: rgba(35, 109, 255, 0.9) !important;
  }
}
</style>